module.exports = __webpack_public_path__ + "assets/img/202110-3.08987c98.png";